import Image from '@next/image';
import classNames from 'classnames';

import { ManufacturerPartnership as ManufacturerPartnershipType } from 'types/models/ManufacturerPartnership';
import Typography from '@components/atoms/Typography';

import classes from './ManufacturerPartnership.module.scss';

type Props = {
  className?: string;
  partnership: ManufacturerPartnershipType;
};

const ManufacturerPartnership = ({ className, partnership }: Props): JSX.Element => (
  <Typography variant="caption2" renderAs="div" className={classNames(classes.partnership, className)}>
    <div className={classes.partnershipImage}>
      <Image
        display="flex"
        objectFit="contain"
        alt={partnership.title}
        resolveConfig={{
          preset: 'svg',
          productName: partnership.title,
          extension: partnership.image.extension,
          name: partnership.image.basename,
          description: partnership.description,
          width: partnership.image.width,
          height: partnership.image.height,
        }}
        hasLazyLoad={false}
      />
    </div>
    <div className={classes.partnershipText}>
      {partnership.title}
      {partnership.description}
    </div>
  </Typography>
);

export default ManufacturerPartnership;
